import React, { useState, useEffect, useRef, useMemo } from "react";
import Loading from "../../../../Student/Reusablecomponents/Loading";

import { Row, Col } from "react-bootstrap";
import axios from "axios";

import { useSelector, useDispatch } from "react-redux";

import {
  Levelone,
  LevelTwo,
  DDGrammer,
} from "../../../../ReusableComponents/MultiselectEnglishQBDropdowns";
import {
  QuestionLevel,
  BloomTaxonomy,
} from "../../../../ReusableComponents/QBDropdowns";
import {
  Situation,
  TextFormat,
  TType,
} from "../../../../ReusableComponents/QBEnglishDropdowns";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";

import EScenario from "../EnglishScenario/EScenarioList";
import EDirectQuestions from "../DirectQuestions";
import {
  GradeDD,
  ChapterDD,
  BookDD,
  Booktype,
} from "../../../../ReusableComponents/QBEnglishDropdowns";

import { FQData } from "../../../../Redux/Reducers/QBAdmin/FilterQDeatails";

import notify from "../../../../ReusableComponents/ToastifyAlerts";

import { useNavigate, useLocation } from "react-router-dom";

import Multiselect from "multiselect-react-dropdown";
import DropdownValues from "../../../../Student/Reusablecomponents/DropDownValues";
const EnglishFilters = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const StatusRef = useRef();
  const ScrollRef = useRef(null);

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage,
  );
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const PNumber =
    PagnatioNumber?.Location === location.pathname &&
    PagnatioNumber?.PageNumber;
  const [CurrentPage, SetCurrentPage] = useState(PNumber || 1);

  const [Load, SetLoad] = useState(false);
  const [Filters, SetFilters] = useState({
    Levelone: [],
    LevelTwo:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.LevelTwo || [],
    Chapter:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Chapter || "",
    Grade: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Grade || "",
    Book: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Book || "",
    Grammer:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Grammer || [],
    Status:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Status || [],
  });
  const [BType, SetBType] = useState();
  const [QLevel, SetQLevel] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.QLevel || "",
  );
  const [BTaxonomy, SetBTaxonomy] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.BTaxonomy || "",
  );
  const [SType, SetSType] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.SType || "",
  );
  const [TFormat, SeTFormat] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.TFormat || "",
  );
  const [TexType, SeTexType] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.TexType || "",
  );
  const [NSBased, SetNSBased] = useState(
    localStorage.getItem("FINQSNS") || "1",
  );
  const [FiltersList, SetFiltersList] = useState();
  const [FilterScenarioList, SetFilterScenarioList] = useState();
  const [FilterQuestionList, SetFilterQuestionList] = useState();
  const [FilterType, SetFilterType] = useState(
    parseInt(localStorage.getItem("EngFType")) || 0,
  );

  const [FSQLParams, SetFSQLParams] = useState({
    Row: "",
    Rowindex: JSON.parse(localStorage.getItem("Rowindex"))?.SIndex || "",
  });

  const StoreFilters = (e, r, Name) => {
    if (Name === "Status") {
      if (Filters[Name].includes(r)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [...Filters[Name], r] });
      }
    } else if (Name === "Grammer" && r.value === 0) {
      if (Filters[Name].includes(r.value)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r.value),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [0] });
      }
    } else {
      if (Filters[Name].includes(r.value)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r.value),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [...Filters[Name], r.value] });
      }
      // CLearvalueremove(Name);
    }
  };
  const CLearvalueremove = (Name) => {
    if (FiltersList) {
      // localStorage.removeItem("FSelected");
      switch (Name) {
        case "Levelone":
          SetFilters({ ...Filters, Levelone: [], LevelTwo: [] });
          break;
        case "LevelTwo":
          SetFilters({ ...Filters, LevelTwo: [] });
          break;
      }
    }
  };

  const StoreStartValue = (e, Name) => {
    SetFilters({ ...Filters, [Name]: e });
  };

  useEffect(() => {
    if (
      !FiltersList &&
      (Filters?.Levelone?.length > 0 || Filters?.Grammer?.length > 0)
    ) {
      GetFiltersList();
    }
  }, [Filters?.Levelone, Filters?.Grammer, NSBased]);
  const HandleEFilters = (e) => {
    SetFiltersList();
    SetQLevel("");
    SetBTaxonomy("");
    SetBType();
    SetFilters({
      Levelone: [],
      LevelTwo: [],
      Chapter: "",
      Grade: "",
      Book: "",
      Grammer: [],
      Status: [],
    });
    SetFilterType(parseInt(e));
    localStorage.setItem("EngFType", e);
  };
  const HandleSNS = (e) => {
    SetFiltersList();
    SetFilterScenarioList();
    SetFilterQuestionList();
    SetNSBased(e);
    localStorage.setItem("FINQSNS", e);
  };
  // Below is filter list
  const GetFiltersList = async () => {
    SetLoad((prev) => !prev);
    SetFilterScenarioList();
    SetFilterQuestionList();
    const data = {
      Filters: Filters,
      QLevel: QLevel,
      BTaxonomy: BTaxonomy,
      BType: BType?.value,
      SType: SType,
      TFormat: TFormat,
      TexType: TexType,
    };
    localStorage.setItem("FSelected", JSON.stringify(data));
    if (Filters?.Levelone?.length > 0 || Filters?.Grammer?.length > 0) {
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
            `/EnglishQuestionBankByLO/GetQuestionBankByFilter?Level1Ids=${
              Filters?.Levelone?.join(",") || 0
            }&Level2Ids=${Filters?.LevelTwo?.join(",") || 0}&IsAllGrammar=${
              Filters?.Grammer.includes(0) ? 1 : 0
            }&SelectedGrammarIds=${Filters?.Grammer?.join(",") || 0}&IsUsed=${
              Filters?.Status?.join(",") || 0
            }&EngGrade=${Filters?.Grade || 0}&EngChapter=${
              Filters?.Chapter || 0
            }&EngBook=${Filters?.Book || 0}&EngBookType=${BType?.value || 0}&QLevel=${
              QLevel || 0
            }&Blooms=${BTaxonomy || 0}&QBCategoryType=${
              location.state?.Tab
            }&IsScenario=${
              location.state?.Tab === "INQ" ? NSBased : 0
            }&Situation=${SType || 0}&TextType=${TFormat || 0}&TextFormat=${
              TexType || 0
            }`,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
        )
        .then((res) => {
          if (res.data[0]?.grammarName || res.data[0]?.level1Name) {
            SetFiltersList(res.data);
          } else {
            SetFiltersList(process.env.REACT_APP_NODATAFOUND);
          }
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      SetLoad((prev) => !prev);
      SetFiltersList();
      notify(`${FilterType ? "Grammar" : "Level 1"} is mandatory`, "warning");
    }
  };

  const FiltersListColumns = [
    ...(FilterType
      ? [{ name: "Grammar", selector: "grammarName", sortable: true }]
      : [
          { name: "Level 1", selector: "level1Name", sortable: true },
          { name: "Level 2", selector: "level2Name", sortable: true },
          { name: "Level 3", selector: "level3Name", sortable: true },
        ]),
    {
      name: "Add/ View",
      sortable: true,
      cell: (row, Rindex) => (
        <div style={{ display: "flex", gap: "3px" }}>
          {location.state.Tab !== "DQ" && NSBased !== "2" && (
            <>
              <div
                className="LinkStyles"
                onClick={() => HandleFilterSCenarioList(row, Rindex)}
              >
                {" "}
                Scenario ({row.sCount}){" "}
              </div>{" "}
              |
            </>
          )}
          <div
            className={
              (location.state.Tab === "DQ" || NSBased === "2") && "LinkStyles"
            }
            onClick={() => HandleFilterQuestionList(row, Rindex)}
          >
            {" "}
            Question ({row.qCount}){" "}
          </div>{" "}
          |
          <div
            className="LinkStyles"
            onClick={() => {
              HandelRemidation(row, Rindex);
            }}
          >
            {" "}
            Remedition ({row.remediationCount}){" "}
          </div>
        </div>
      ),
    },
  ];
  // Above is filter list

  // Below are Scenario List
  const HandleFilterSCenarioList = (Row, Rindex) => {
    //   // StoreFilterValues();
    dispatch(FQData({ FQDetails: Row }));
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = {
      SIndex: Rindex,
      CPage: CurrentPage,
    };
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    if (location.state.Tab === "SCQ") {
      FiltersScenarioList(Row);
    } else if (location.state.Tab === "INQ" && NSBased === "1") {
      INFScenarioList(Row);
    }
  };

  const FiltersScenarioList = async (Row, QType) => {
    SetFilterScenarioList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/EnglishQuestionBankByLO/GetEnglishScenarioByLO?LovId1=${
            Row?.level1Id
          }&LovId2=${Row?.level2Id}&LovId3=${
            Row?.level3Id || Row?.grammarId
          }&GradeId=${Filters?.Grade || 0}&ChapterId=${
            Filters?.Chapter || 0
          }&BookId=${Filters?.Book || 0}&QLevelId=${QLevel || 0}&BloomsId=${
            BTaxonomy || 0
          }&Used=${Filters?.Status?.join(",") || 0}&SituationId=${
            SType || 0
          }&TextTypeId=${TexType || 0}&TextFormatId=${TFormat || 0}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        if (res.data?.[0]?.scenarioID) {
          SetFilterScenarioList(res.data);
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 1000);
        } else {
          SetFilterScenarioList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const INFScenarioList = async (Row) => {
    SetFilterScenarioList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/EnglishQuestionBankByLO/GetInputBasedDataByLO?LovId1=${
            Row?.level1Id
          }&LovId2=${Row?.level2Id}&LovId3=${
            Row?.level3Id || Row?.grammarId
          }&GradeId=${Filters?.Grade || 0}&ChapterId=${
            Filters?.Chapter || 0
          }&BookId=${Filters?.Book || 0}&QLevelId=${QLevel || 0}&BloomsId=${
            BTaxonomy || 0
          }&Used=${
            Filters?.Status?.join(",") || 0
          }&IsScenario=${NSBased}&BookType=${BType?.value || 0}&SituationId=${
            SType || 0
          }&TextTypeId=${TexType || 0}&TextFormatId=${TFormat || 0}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        if (res.data?.[0]?.scenarioID || res.data?.[0]?.questionID) {
          if (NSBased == 1) {
            SetFilterScenarioList(res.data);
          } else {
            SetFilterQuestionList(res.data);
          }
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 1000);
        } else {
          if (NSBased == 1) {
            SetFilterScenarioList(process.env.REACT_APP_NODATAFOUND);
          } else {
            SetFilterQuestionList(process.env.REACT_APP_NODATAFOUND);
          }
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Above are Scenario List

  // Below are Questions List
  const HandleFilterQuestionList = (Row, Rindex) => {
    if (location.state?.Tab === "DQ" || NSBased === "2") {
      SetFSQLParams({ Row: Row, Rowindex: Rindex });
      const SelectRow = {
        SIndex: Rindex,
        CPage: CurrentPage,
      };
      localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
      dispatch(FQData({ FQDetails: Row }));
      if (location.state?.Tab === "DQ") {
        FiltersQuestionList(Row);
      } else if (location.state?.Tab === "INQ" && NSBased === "2") {
        INFScenarioList(Row);
      }
    }
  };

  const FiltersQuestionList = async (Row, Qtype) => {
    SetFilterQuestionList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/EnglishQuestionBankByLO/GetEnglishQuestionByLO?LovId1=${
            Row?.level1Id || 0
          }&LovId2=${Row?.level2Id || 0}&LovId3=${
            Row?.level3Id || Row?.grammarId
          }&GradeId=${Filters?.Grade || 0}&ChapterId=${
            Filters?.Chapter || 0
          }&BookId=${Filters?.Book || 0}&QLevelId=${QLevel || 0}&BloomsId=${
            BTaxonomy || 0
          }&Used=${Filters?.Status?.join(",") || 0}&BookType=${
            BType?.value || 0
          }&SituationId=${SType || 0}&TextTypeId=${TexType || 0}&TextFormatId=${
            TFormat || 0
          }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        if (res.data?.[0]?.questionID) {
          SetFilterQuestionList(res.data);
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 1000);
        } else {
          SetFilterQuestionList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Above are Questions List

  // Below is Remidation List
  const HandelRemidation = (Row, Rindex) => {
    // StoreFilterValues();
    // SetFilters({ Topic: [], SubTopic: [], LOC: [], SubLOC: [], Chapter: [], Grade: [], Status: [], });
    // SetRContent(!RContent);
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = {
      SIndex: Rindex,
      CPage: CurrentPage,
    };
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    dispatch(FQData({ FQDetails: Row }));
    navigate("/QBAdmin/QuestionBank/Remidation", {
      state: { Tab: location.state?.Tab },
    });
  };
  // Above is Remidation List
  const ClearAllSTates = () => {
    localStorage.removeItem("FSelected");
    SetFiltersList();
    SetFilterScenarioList();
    SetFilterQuestionList(); /*SetSelectedRow();*/
    SetNSBased("1");
    /*SetINBFQList();*/ SetFSQLParams({ Row: "", Rowindex: "" });
    localStorage.removeItem("Rowindex");
    SetQLevel("");
    SetBTaxonomy("");
    SetBType();
    SetFilters({
      Levelone: [],
      LevelTwo: [],
      Chapter: "",
      Grade: "",
      Book: "",
      Grammer: [],
    });
  };
  useMemo(() => {
    if (FiltersList) {
      localStorage.removeItem("FSelected");
      ClearAllSTates();
    }
  }, [location.state.Tab]);

  useMemo(() => {
    if (CurrentPage != JSON.parse(localStorage.getItem("Rowindex"))?.CPage) {
      SetFSQLParams({ Row: "", Rowindex: "" });
      localStorage.removeItem("Rowindex");
      SetFilterScenarioList();
      SetFilterQuestionList();
    }
  }, [CurrentPage]);
  return (
    <>
      {location.state?.Tab === "INQ" && (
        <div className="dflex JCCenter m-3" style={{ gap: "15px" }}>
          {["1", "2"].map((Item) => (
            <div key={Item} className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                value={Item}
                name="NONSCENario"
                checked={NSBased === Item}
                onChange={(e) => HandleSNS(e.target.value)}
              />
              {Item === "1" ? "Scenario Based" : "Non Scenario Based"}
            </div>
          ))}
        </div>
      )}
      <div className="dflex JSBetween">
        <div></div>
        <div>
          <DropdownValues
            className="NCLDropdown"
            options={[
              { display: "Reading Comprehension", value: 0 },
              { display: "Grammar", value: 1 },
            ]}
            selectoption={FilterType}
            onChange={(e) => HandleEFilters(e.target.value)}
            labelname={<div className="DropdownHeader">Select</div>}
          />
        </div>
      </div>

      <div className=" Card container-fluid mt-2 mb-2">
        {FilterType ? (
          <>
            <Row>
              <Col>
                <DDGrammer
                  SubjectId={items?.subjectId}
                  className="NCLDropdown"
                  Selected={Filters?.Grammer}
                  onChange={(e, r) => StoreFilters(e, r, "Grammer")}
                  StoreOptions={(e) => StoreStartValue(e, "Grammer")}
                  Preselected={Filters?.Grammer?.length}
                  selectionLimit={Filters?.Grammer.includes(0) ? 1 : -1}
                />
              </Col>
              <Col>
                <QuestionLevel
                  className="NCLDropdown w-100"
                  SubjectId={items?.subjectId}
                  /*StoreValue={SetQLevel}*/ SOption={QLevel}
                  onChange={(e) => SetQLevel(e)}
                  LovCategoryId={43}
                  Displayname="Select Question Level"
                  labelname={
                    <div className="DropdownHeader">Question Level</div>
                  }
                  LID={SelectLanguage}
                />
              </Col>
              <Col>
                <BloomTaxonomy
                  className="NCLDropdown w-100"
                  SubjectId={items?.subjectId}
                  PId={QLevel}
                  StoreValue={SetBTaxonomy}
                  SOption={BTaxonomy}
                  onChange={(e) => SetBTaxonomy(e)}
                  LovCategoryId={44}
                  labelname={
                    <div className="DropdownHeader">Bloom's Taxonomy</div>
                  }
                  LID={SelectLanguage}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row>
              <Col>
                <Levelone
                  className="NCLDropdown"
                  SubjectId={
                    items?.subjectId
                  } /*Pid={Filters?.Characteristics?.join(",")}*/
                  onChange={(e, r) => StoreFilters(e, r, "Levelone")}
                  StoreOptions={(e) => StoreStartValue(e, "Levelone")}
                  Selected={
                    JSON.parse(localStorage.getItem("FSelected"))?.Filters
                      ?.Levelone
                  }
                  Preselected={Filters?.Levelone?.length}
                  // clear={(Name) => CLearvalueremove(Name)}
                />
              </Col>
              <Col>
                <LevelTwo
                  className="NCLDropdown"
                  Pid={Filters?.Levelone?.join(",")}
                  onChange={(e, r) => StoreFilters(e, r, "LevelTwo")}
                  Preselected={
                    JSON.parse(localStorage.getItem("FSelected"))?.Filters
                      ?.LevelTwo
                  }
                  clear={(Name) => CLearvalueremove(Name)}
                />
              </Col>

              <Col>
                <div className="DropdownHeaderNIMP">
                  Status :{" "}
                  <Multiselect
                    onRemove={(e, r) => StoreFilters(e, r, "Status")}
                    onSelect={(e, r) => StoreFilters(e, r, "Status")}
                    style={{ searchBox: { minHeight: "15vh" } }}
                    isObject={false}
                    placeholder=""
                    showCheckbox
                    ref={StatusRef}
                    avoidHighlightFirstOption="true"
                    options={["Used", "Unused", "Mapped", "Unmapped", "NA"]}
                    selectedValues={Filters?.Status}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <Situation
                  SID={items?.subjectId}
                  LID="33"
                  className="NCLDropdown w-100"
                  /*StoreMSource={SetSType}*/ SOption={SType}
                  onChange={(e) => SetSType(e)}
                  Displayname="Select Situation"
                  labelname={<div className="DropdownHeader">Situation</div>}
                />
              </Col>
              <Col>
                <TextFormat
                  SID={items?.subjectId}
                  LID="33"
                  className="NCLDropdown w-100"
                  /*StoreMSource={SeTFormat}*/ SOption={TFormat}
                  onChange={(e) => SeTFormat(e)}
                  Displayname="Select Text Format"
                  labelname={<div className="DropdownHeader">Text Format</div>}
                />
              </Col>
              <Col>
                <TType
                  SID={items?.subjectId}
                  LID="33"
                  className="NCLDropdown w-100"
                  /*StoreMSource={SeTexType}*/ SOption={TexType}
                  onChange={(e) => SeTexType(e)}
                  Displayname="Select Text Type"
                  labelname={<div className="DropdownHeader">Text Type</div>}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <GradeDD
                  className="w-100 NCLDropdown"
                  Displayname="Select Grade"
                  SOption={Filters?.Grade}
                  onChange={(e) => SetFilters({ ...Filters, Grade: e })}
                  labelname={<div className="DropdownHeader">Grade</div>}
                />
              </Col>
              {Filters?.Grade != "" && (
                <Col>
                  {" "}
                  <Booktype
                    className={`w-100 ${
                      Filters?.Grade === 52 || Filters?.Grade === 51
                        ? "NCLDropdown"
                        : "DisabledNCLDropdown"
                    }`}
                    StoreMSource={SetBType}
                    SOption={BType?.value}
                    Grade={Filters?.Grade}
                    onChange={(e) => SetBType(e)}
                    disable={Filters?.Grade !== 52 && Filters?.Grade !== 51}
                    labelname={
                      <div className="DropdownHeader">
                        Book Type<span>*</span>
                      </div>
                    }
                  />{" "}
                </Col>
              )}
              <Col>
                {" "}
                <ChapterDD
                  LID="50"
                  className="w-100 NCLDropdown"
                  Displayname="Select Chapter"
                  SOption={Filters?.Chapter}
                  onChange={(e) => SetFilters({ ...Filters, Chapter: e })}
                  labelname={
                    <div className="DropdownHeader">
                      CBSE / SCERT Chapter No
                    </div>
                  }
                />
              </Col>
              <Col>
                <BookDD
                  className="w-100 NCLDropdown"
                  Displayname="Select Book"
                  Grade={Filters?.Grade}
                  Chapter={Filters?.Chapter}
                  GCtype={BType?.value}
                  /*StoreMSource={SetBook}*/ SOption={Filters?.Book}
                  onChange={(e) => SetFilters({ ...Filters, Book: e })}
                  labelname={<div className="DropdownHeader">Book</div>}
                />
              </Col>
            </Row>
          </>
        )}
        <div className="dflex gap-3 mt-2">
          <button
            className="Buttons CancleButton"
            onClick={() => ClearAllSTates()}
          >
            {" "}
            Clear{" "}
          </button>
          <button
            className="Buttons "
            onClick={() => {
              GetFiltersList();
              SetFSQLParams();
            }}
          >
            {" "}
            Go{" "}
          </button>
        </div>
      </div>

      {FiltersList && (
        <div className="Card" ref={ScrollRef}>
          <DataTable
            className="NCLDataTable"
            data={FiltersList}
            columns={FiltersListColumns}
            Selected={parseInt(FSQLParams?.Rowindex)}
            Dropdownvalues={["10", "25", "50", "100"]}
            ShowPagination="true"
            ShowPagecount="true"
            GetCurrentPage={SetCurrentPage}
            Selectedpage={JSON.parse(localStorage.getItem("Rowindex"))?.CPage}
          />
        </div>
      )}

      {(FilterScenarioList || FilterQuestionList) && (
        <div className="dflex alignitems mt-4">
          English &gt; {FQuestionDetails?.level1Name}{" "}
          {!FQuestionDetails?.grammarName && "> "}{" "}
          {FQuestionDetails?.level2Name}{" "}
          {!FQuestionDetails?.grammarName && "> "}{" "}
          <b className="text-success">
            {FQuestionDetails?.level3Name || FQuestionDetails?.grammarName}
          </b>
        </div>
      )}

      {FilterScenarioList && <EScenario data={FilterScenarioList} />}
      {FilterQuestionList && (
        <EDirectQuestions
          data={FilterQuestionList}
          Filtersfunction={() =>
            HandleFilterQuestionList(FSQLParams?.Row, FSQLParams?.Rowindex)
          }
        />
      )}
      {Load && <Loading />}
    </>
  );
};
export default EnglishFilters;
